import { InputRule } from "@handlewithcare/prosemirror-inputrules";
import { type NodeType } from "prosemirror-model";
import { type EditorState } from "prosemirror-state";

// Regex to match GitHub PR URLs
// Matches: https://github.com/owner/repo/pull/123
// Also matches: http://github.com/owner/repo/pull/123
// Also matches: github.com/owner/repo/pull/123 (without protocol)
const githubPrRegex = /(https?:\/\/)?(www\.)?github\.com\/([^/\s]+)\/([^/\s]+)\/pull\/(\d+)\s+$/;

export const linkPullRequestRule = (nodeType: NodeType): InputRule => {
	const matchHandler = function (
		state: EditorState,
		match: RegExpMatchArray,
		start: number,
		end: number
	) {
		const tr = state.tr;
		const matchedString = match[0];
		const trimmedMatchedString = matchedString.trim();

		if (matchedString === undefined) {
			return tr;
		}

		// Extract the components from the URL
		const owner = match[3]; // The owner/org part
		const repo = match[4]; // The repository name
		const prNumber = match[5]; // The PR number

		// Create the full URL
		let fullUrl = trimmedMatchedString;
		if (!match[1]) {
			// If no protocol was provided, default to https
			fullUrl = `https://${trimmedMatchedString}`;
		}

		// Create the PR node
		return tr.replaceWith(
			start,
			end,
			nodeType.create({
				url: fullUrl,
				owner,
				repo,
				prNumber: parseInt(prNumber, 10),
			})
		);
	};

	return new InputRule(githubPrRegex, matchHandler);
};
